module.exports = __webpack_public_path__ + "_static/img/ico_hashgame.1cb760c5.png";